import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { FontIcon } from 'react-toolbox';
import cx from 'classnames';

import styles from './pageActionButton.scss';

const PageActionButton = (props) => {
  const actionText = props.actionText || 'Text';
  const actionIcon = props.actionIcon || 'report';
  const actionColor = props.actionColor || 'blue';

  const filterClasses = cx([styles.actions, styles[actionColor]]);

  const children = (<div className={styles.button}>
    <FontIcon value={actionIcon} />
    <div className={styles.iconButtonText}>{actionText}</div>
  </div>);

  return (
    typeof props.action === 'string'
      ? <Link className={filterClasses} to={props.action}>{children}</Link>
      : <button className={filterClasses} onClick={props.action}>{children}</button>
  );
};

PageActionButton.propTypes = {
  actionText: PropTypes.string,
  actionIcon: PropTypes.string,
  actionColor: PropTypes.string,
  action: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
  ]),
};

export default PageActionButton;



// WEBPACK FOOTER //
// ./client/app/shared/components/PageActionButton/index.jsx